import { Caption, Text } from '@/shared/components/typography'

type NoticeProps = {
  title: string
  text: string
}

const Notice = ({ title, text }: NoticeProps) => (
  <section className="section flex flex-col gap-4 px-4 first-of-type:pt-0">
    <Text level="text2" weight="bold" color="text090">
      {title}
    </Text>
    <Caption level="caption1" color="text090">
      {text}
    </Caption>
  </section>
)

export default Notice
